import React, { type FunctionComponent } from 'react'
import { css } from '@emotion/react'
import { GridList, spacing, withContainerSize } from '@retailer-platform/shared-components'
import { PageHeader } from '@retailer-platform/shared-components'
import { BannerBreadcrumbs } from 'domains/banners/components/banner-breadcrumbs/BannerBreadcrumbs'
import DocumentTitle from 'legacy/components/DocumentTitle'
import BannersListFilters from 'domains/banners/components/banners-list/components/filters/BannersListFilters'
import { useBannerList } from 'domains/banners/utils/useQueryBannerList.hooks'

const ExpandableGridList = withContainerSize(GridList)

const pageWrapper = css({
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
})

const gridWrapper = css({
  flex: 1,
  padding: `0 ${spacing.X20}`,
  overflow: 'hidden',
})

export const BannersList: FunctionComponent = () => {
  const { searchBanners, apiLoading, apiError, columns, banners } = useBannerList()

  return (
    <div css={pageWrapper}>
      <DocumentTitle titleId="bannersDomain.list.title" />
      <PageHeader addBottomPadding title={<BannerBreadcrumbs pageType="list" />}></PageHeader>
      <BannersListFilters searchBanners={searchBanners} />
      <div css={gridWrapper}>
        <ExpandableGridList
          onLoadMore={() => {
            /* noop */
          }}
          data={banners}
          columns={columns}
          loadingMore={apiLoading}
          canLoadMore={false}
          errorMessage={apiError && apiError.message}
        />
      </div>
    </div>
  )
}
